export const environment = {
  production: false,
  apiUrl: 'https://apiv3.plataformaasap.com.br',
  baseUrl: 'https://apiv3.plataformaasap.com.br',
  filestack: { key: 'AD5oDjsJaTJOzLe1Llj9mz' },
  pusher: { key: 'eaf41725f3b027147953' },
  firebase: {
    apiKey: "AIzaSyC2eHdV7uyIAS48OHHHjq5JseoyPFoGS5Y",
    authDomain: "plataforma-bio-ritmo.firebaseapp.com",
    databaseURL: "https://plataforma-bio-ritmo.firebaseio.com",
    projectId: "plataforma-bio-ritmo",
    storageBucket: "plataforma-bio-ritmo.appspot.com",
    messagingSenderId: "338003385436"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts